










import HasTaskMixin from '../../components/HasTaskMixin';
import InviteUserBtn from '../../user/invite/InviteUserBtn.vue';
import { AccountSubscriber, User } from '../../types';
import { subscribe } from '.';

export default HasTaskMixin.extend({
  props: {
    parentId: {
      type: String,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Add System User',
    },
  },
  methods: {
    subscribe(user: User): void {
      this.task = subscribe(this.accountId, user.id);
      this.task.then((subscriber: AccountSubscriber) => {
        this.$emit('subscribed', subscriber);
      });
    },
  },
  components: {
    InviteUserBtn,
  },
});
